import script from "./carousalCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./carousalCard.vue?vue&type=script&setup=true&lang=ts"

import "./carousalCard.vue?vue&type=style&index=0&id=0c91ac71&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c91ac71"]])

export default __exports__